interface LoggerOptions {
  tag: string;
}

interface LoggerConfiguration extends LoggerOptions {
  level: 'debug' | 'log' | 'warn' | 'error' | 'info';
  enable: boolean;
  isWrite: boolean;
  tags: string[];
  excludeTag: string[];
}

class Logger {
  private configuration: LoggerConfiguration;

  constructor(options: LoggerOptions) {
    this.configuration = {
      level: 'debug',
      tag: options.tag,
      enable: true,
      isWrite: false,
      tags: [],
      excludeTag: [],
    };
  }

  log(...args: unknown[]): void {
    if (
      this.configuration.level === 'log' ||
      this.configuration.level === 'debug'
    ) {
      this.print('log', args);
    }
  }

  error(...args: unknown[]): void {
    if (this.configuration.enable) {
      this.print('error', args);
    }
  }

  warn(...args: unknown[]): void {
    if (
      this.configuration.level === 'warn' ||
      this.configuration.level === 'debug'
    ) {
      this.print('warn', args);
    }
  }

  debug(...args: unknown[]): void {
    if (this.configuration.level === 'debug') {
      this.print('debug', args);
    }
  }

  info(...args: unknown[]): void {
    if (this.configuration.level === 'info') {
      this.print('info', args);
    }
  }

  private print(level: LoggerConfiguration['level'], args: unknown[]): void {
    if (this.configuration.enable) {
      if (
        level !== 'error' &&
        (this.configuration.excludeTag.includes(this.configuration.tag) ||
          (this.configuration.tags.length &&
            !this.configuration.tags.includes(this.configuration.tag)))
      ) {
        return;
      }

      const content = [`[${this.configuration.tag}]`, ...args];

      const consoleMethod = console[level] as (...args: unknown[]) => void;
      consoleMethod(...content);
    }
  }
}

export default Logger;
